export default __webpack_public_path__ + "static/media/product.98b1e893.svg";